import {useEffect} from 'react';

export default function useLockHTMLScroll({
  lockBodyClass,
  stateOnWhichLockToggles,
}: {
  lockBodyClass?: string;
  stateOnWhichLockToggles: boolean;
}) {
  const htmlLockClassName = lockBodyClass || 'lock-scroll';

  const htmlEl = () => document?.querySelector('html');

  const lockHTMLScroll = () => {
    const el = htmlEl();
    el?.classList?.add(htmlLockClassName);
  };

  const unLockHTMLScroll = () => {
    const el = htmlEl();
    el?.classList?.remove(htmlLockClassName);
  };

  useEffect(() => {
    if (stateOnWhichLockToggles) {
      // make html not scrollable
      lockHTMLScroll();
    } else {
      unLockHTMLScroll();
    }
  }, [stateOnWhichLockToggles]);

  useEffect(() => {
    return () => {
      // bring back scroll on unmount
      unLockHTMLScroll();
    };
  }, []);
}
